var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2C13.8175 2 10 5.81752 10 10.5C10 13.8003 11.9499 16.5929 14.709 18C11.9499 19.4071 10 22.1997 10 25.5C10 28.8003 11.9499 31.5929 14.709 33C11.9499 34.4071 10 37.1997 10 40.5C10 45.1825 13.8175 49 18.5 49C23.1825 49 27 45.1825 27 40.5V33V29.6562C28.3414 32.2017 30.9321 34 34 34C38.4064 34 42 30.4064 42 26C42 22.3782 39.5262 19.4287 36.2148 18.4492C39.5536 17.3017 42 14.2202 42 10.5C42 5.81752 38.1825 2 33.5 2H26H18.5ZM18.5 4H25V17H18.5C14.8985 17 12 14.1015 12 10.5C12 6.89848 14.8985 4 18.5 4ZM27 4H33.5C37.1015 4 40 6.89848 40 10.5C40 14.1015 37.1015 17 33.5 17H27V4ZM18.5 19H25V32H18.5C14.8985 32 12 29.1015 12 25.5C12 21.8985 14.8985 19 18.5 19ZM27 19H30.3438C28.9088 19.7561 27.7561 20.9088 27 22.3438V19ZM34 20C37.3256 20 40 22.6744 40 26C40 29.3256 37.3256 32 34 32C30.6744 32 28 29.3256 28 26C28 22.6744 30.6744 20 34 20ZM18.5 34H25V40.5C25 44.1015 22.1015 47 18.5 47C14.8985 47 12 44.1015 12 40.5C12 36.8985 14.8985 34 18.5 34Z",
    fill: "#C9E4CA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.c3b6d244b329727e5bd38e2e43476d0c.svg";
export { ForwardRef as ReactComponent };